import React from "react";
import { Navigate } from "react-router-dom";
import { getToken, GetSocialLoginToken } from "./LocalStorage";

const RedirectLoginUserAuth = ({ children }) => {
  const Token = getToken();
  const SlToken = GetSocialLoginToken();

  if (Token || SlToken) {
    return <Navigate to={"/dashboard"} />;
  }
  return children;
};

export default RedirectLoginUserAuth;
